import { render, staticRenderFns } from "./gaopaiyi.vue?vue&type=template&id=399ed517&scoped=true"
import script from "./gaopaiyi.vue?vue&type=script&lang=js"
export * from "./gaopaiyi.vue?vue&type=script&lang=js"
import style0 from "./gaopaiyi.vue?vue&type=style&index=0&id=399ed517&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399ed517",
  null
  
)

export default component.exports